/* storybook-check-ignore */
import { useRef } from 'react';

import { Box } from '@opendoor/bricks-next';
import { Divider } from '@opendoor/bricks/core';

import { FooterCTA, PropertyDetailsType, SimilarListings } from 'components/marketplace/property';
import { useInViewAfterLoad } from 'components/shared/hooks/useInView';

import { PropertyCTAs } from './PropertyCTAs';
import { PropertyDetails } from './PropertyDetails';
import { PropertyStatus } from './PropertyStatus';
import { PropertySummary } from './PropertySummary';

type PropertySectionProps = {
  property: PropertyDetailsType;
};

export const PropertySection = ({ property }: PropertySectionProps) => {
  const ctaRef = useRef<HTMLDivElement>(null);
  const { inView } = useInViewAfterLoad({ ref: ctaRef, threshold: 0 });

  return (
    <Box
      flexDirection="column"
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      $largerThanSM={{ flexBasis: '50%', mt: 55, overflowY: 'scroll' }}
      $largerThanLG={{ maxWidth: '$736x' }}
    >
      <Box $largerThanSM={{ px: 48 }} $smallerThanMD={{ px: 24 }} pt={24}>
        <PropertyStatus property={property} />
        <PropertySummary property={property} />
        <Box ref={ctaRef}>
          <PropertyCTAs property={property} />
        </Box>
        <Divider mt={48} />
        <PropertyDetails property={property} />
        <Box tag="section">
          <SimilarListings listings={property?.similarProperties?.results || []} />
        </Box>
      </Box>
      <FooterCTA property={property} isVisible={!inView} />
    </Box>
  );
};
